function HeaderRow({ row }) {
  return (
    <tr className="bg-neutral-10 odd:bg-white">
      <td className="h-10 overflow-hidden text-ellipsis whitespace-nowrap border-b border-neutral-9 px-2.5 text-sm">
        {row.label}
      </td>
    </tr>
  )
}

export default function HeaderColumn({ rowsTitle, rows }) {
  return (
    <div className="z-10 mt-12">
      <table className="mr-1.5 mt-0.5 w-52 table-fixed border-collapse border-none text-neutral-4 shadow-md">
        <tbody>
          <tr className="bg-white">
            <th className="border-color-neutral-900 h-10 overflow-hidden text-ellipsis whitespace-nowrap border-b px-3.5 pb-1.5 pt-2.5 text-sm">
              {rowsTitle}
            </th>
          </tr>
          {rows.map((row, i) => (
            <HeaderRow key={`${row.label}-${i}`} row={row} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
